'use client';

import { ComponentProps } from 'react';
import Typography from '@alltrails/core/components/Typography';
import TrailStatus from '@alltrails/types/TrailStatus';
import layoutStyles from '../layouts/layoutStyles.module.scss';
import styles from './TrailHeader.module.scss';

type TrailHeaderProps = {
  trailName: string;
  trailStatus?: TrailStatus;
  variant?: ComponentProps<typeof Typography>['variant'];
  seoTestH1?: string;
};

const TrailHeader = ({ trailName, trailStatus, seoTestH1 }: TrailHeaderProps) => {
  const displayName = trailStatus === TrailStatus.Pending ? `${trailName} [PENDING]` : trailName;

  return (
    <div className={layoutStyles.colLayout}>
      <h1 className={styles.header}>{seoTestH1 ?? displayName}</h1>
    </div>
  );
};

export default TrailHeader;
